<template>
  <div
    class="m-guest new wap top-nav"
    v-if="extras.groupGuestDisplay && extras.groupGuestDisplay.display == 1"
    :style="{
      background:
        extras.guestBg.colorOrBg == 'color'
          ? extras.guestBg.color
          : 'url(' + extras.guestBg.src + ')',
    }"
    id="guest"
  >
    <WapTitle
      v-if="extras.guestTitle.display == 1"
      :title="extras.guestTitle.mainTitle || title"
      :en="extras.guestTitle.subTitle || en"
      :extras="extras"
    />
    <div class="g-guest-desc">
      <div class="guest-swiper">
        <ul
          class="list"
          v-if="guests.length > 2 && extras.guestCardStyle.style == 1"
        >
          <swiper :options="swiperOptions">
            <swiper-slide
              v-for="(guest, index) in guests"
              :key="index"
              class="swiper-slide"
              :data-index="index"
            >
              <div :data-index="index" class="seminar-guest-info">
                <div class="head-area" :data-index="index">
                  <div class="head-outer" :data-index="index">
                    <img
                      class="head-img"
                      :data-index="index"
                      :src="guest.realPath || defaultHeader"
                      :alt="guest.name"
                    />
                    <div class="img-bg" :data-index="index">
                      <img
                        :data-index="index"
                        :src="
                          extras.guestStyle.colorOrBg == 'src'
                            ? extras.guestStyle.src
                            : ''
                        "
                        alt=""
                        :style="{
                          background:
                            extras.guestStyle.colorOrBg == 'color'
                              ? extras.guestStyle.color
                              : '',
                        }"
                      />
                    </div>
                    <div class="img-bg-active" :data-index="index">
                      <img
                        :src="
                          extras.guestStyle.colorOrBg2 == 'src'
                            ? extras.guestStyle.img
                            : ''
                        "
                        alt=""
                        :style="{
                          background:
                            extras.guestStyle.colorOrBg2 == 'color'
                              ? extras.guestStyle.color2
                              : '',
                        }"
                        :data-index="index"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="g-info-bottom"
                  :style="{
                    background:
                      extras.guestStyle.card == 'custom'
                        ? extras.guestStyle.color3
                        : '',
                  }"
                >
                  <div
                    class="name"
                    v-if="extras.guestName.display == 1"
                    :style="{
                      color:
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontColor
                          : '',

                      'font-style':
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    }"
                  >
                    {{
                      $i18nField(
                        guestsI18n && guestsI18n[guest.seminarGuestId],
                        "name",
                        guest.name
                      )
                    }}
                  </div>
                  <div
                    class="position"
                    v-if="extras.guestEnterprise.display == 1"
                    :style="{
                      color:
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.guestEnterprise.fontColor
                          : '',

                      'font-style':
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.guestEnterprise.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.guestEnterprise.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    }"
                  >
                    {{
                      $i18nField(
                        guestsI18n && guestsI18n[guest.seminarGuestId],
                        "enterprise",
                        guest.enterprise
                      )
                    }}
                  </div>
                  <div
                    class="position"
                    v-if="extras.guestDuty.display == 1"
                    :style="{
                      color:
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontColor
                          : '',

                      'font-style':
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    }"
                  >
                    {{
                      $i18nField(
                        guestsI18n && guestsI18n[guest.seminarGuestId],
                        "duty",
                        guest.duty
                      )
                    }}
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination"></div>
        </ul>
        <ul class="list single" v-if="extras.guestCardStyle.style == 2">
          <swiper :options="swiperOptions2">
            <swiper-slide
              v-for="(guest, index) in guests"
              :key="index"
              class="swiper-slide"
            >
              <div
                class="seminar-guest-info single"
                :class="extras.guestStyle.headType == 2 ? 'circle' : ''"
                @click="showDetail(guest)"
              >
                <div
                  class="item"
                  :style="{
                    background:
                      extras.guestStyle.colorOrBg == 'color'
                        ? extras.guestStyle.color
                        : 'url(' + extras.guestStyle.src + ')',
                  }"
                >
                  <div
                    class="name"
                    v-if="extras.guestName.display == 1"
                    :style="{
                      color:
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontColor
                          : '',

                      'font-style':
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    }"
                  >
                    {{
                      $i18nField(
                        guestsI18n && guestsI18n[guest.seminarGuestId],
                        "name",
                        guest.name
                      )
                    }}
                  </div>
                  <div class="spite-line low"></div>
                  <div
                    class="position"
                    v-if="extras.guestEnterprise.display == 1"
                    :style="{
                      color:
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.guestEnterprise.fontColor
                          : '',

                      'font-style':
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.guestEnterprise.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.guestEnterprise.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    }"
                  >
                    {{
                      $i18nField(
                        guestsI18n && guestsI18n[guest.seminarGuestId],
                        "enterprise",
                        guest.enterprise
                      )
                    }}
                  </div>
                  <div
                    class="position center"
                    v-if="extras.guestDuty.display == 1"
                    :style="{
                      color:
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontColor
                          : '',

                      'font-style':
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    }"
                  >
                    {{
                      $i18nField(
                        guestsI18n && guestsI18n[guest.seminarGuestId],
                        "duty",
                        guest.duty
                      )
                    }}
                  </div>
                </div>
                <div class="head-img">
                  <img :src="guest.realPath || defaultHeader" />
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination"></div>

          <div class="swiper-button-prev" v-if="guests.length > 2">
            <div
              class="delta_empty _left"
              :style="{
                'border-color':
                  extras.guestStyle.button == 'custom'
                    ? extras.guestStyle.color4
                    : '',
              }"
            ></div>
            <div
              class="delta _left"
              :style="{
                'border-right-color':
                  extras.guestStyle.button == 'custom'
                    ? extras.guestStyle.color4
                    : '',
              }"
            ></div>
          </div>
          <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
          <div class="swiper-button-next" v-if="guests.length > 2">
            <div
              class="delta _right"
              :style="{
                'border-left-color':
                  extras.guestStyle.button == 'custom'
                    ? extras.guestStyle.color4
                    : '',
              }"
            ></div>
            <div
              class="delta_empty _right"
              :style="{
                'border-color':
                  extras.guestStyle.button == 'custom'
                    ? extras.guestStyle.color4
                    : '',
              }"
            ></div>
          </div>
        </ul>
        <ul
          class="list"
          v-if="
            guests.length <= 2 &&
            guests.length > 0 &&
            extras.guestCardStyle.style == 1
          "
        >
          <div style="display: flex; justify-content: space-evenly">
            <div
              v-for="(guest, index) in guests"
              :key="index"
              class="swiper-slide"
            >
              <div class="seminar-guest-info">
                <div class="head-area">
                  <div class="head-outer">
                    <img
                      class="head-img"
                      :src="guest.realPath || defaultHeader"
                      :alt="guest.name"
                    />

                    <div class="img-bg">
                      <img
                        :src="
                          extras.guestStyle.colorOrBg == 'src'
                            ? extras.guestStyle.src
                            : ''
                        "
                        alt=""
                        :style="{
                          background:
                            extras.guestStyle.colorOrBg == 'color'
                              ? extras.guestStyle.color
                              : '',
                        }"
                      />
                    </div>

                    <div class="img-bg-active">
                      <img
                        :src="
                          extras.guestStyle.colorOrBg2 == 'src'
                            ? extras.guestStyle.img
                            : ''
                        "
                        alt=""
                        :style="{
                          background:
                            extras.guestStyle.colorOrBg2 == 'color'
                              ? extras.guestStyle.color2
                              : '',
                        }"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="g-info-bottom"
                  :style="{
                    background:
                      extras.guestStyle.card == 'custom'
                        ? extras.guestStyle.color3
                        : '',
                  }"
                >
                  <div
                    class="name"
                    v-if="extras.guestName.display == 1"
                    :style="{
                      color:
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontColor
                          : '',

                      'font-style':
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        extras.guestName.name == 'custom'
                          ? extras.guestName.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    }"
                  >
                    {{
                      $i18nField(
                        guestsI18n && guestsI18n[guest.seminarGuestId],
                        "name",
                        guest.name
                      )
                    }}
                  </div>
                  <div
                    class="position"
                    v-if="extras.guestEnterprise.display == 1"
                    :style="{
                      color:
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.enterprise.fontColor
                          : '',

                      'font-style':
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.enterprise.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        extras.guestEnterprise.enterprise == 'custom'
                          ? extras.enterprise.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    }"
                  >
                    {{
                      $i18nField(
                        guestsI18n && guestsI18n[guest.seminarGuestId],
                        "enterprise",
                        guest.enterprise
                      )
                    }}
                  </div>
                  <div
                    class="position"
                    v-if="extras.guestDuty.display == 1"
                    :style="{
                      color:
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontColor
                          : '',

                      'font-style':
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        extras.guestDuty.duty == 'custom'
                          ? extras.guestDuty.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    }"
                  >
                    {{
                      $i18nField(
                        guestsI18n && guestsI18n[guest.seminarGuestId],
                        "duty",
                        guest.duty
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ul>
        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
      </div>

      <div class="no-data" v-if="guests.length == 0">
        <img :src="require('@/assets/images/nodata.png')" />
        <div class="no-data-text">{{ $t("暂无数据") }}</div>
      </div>

      <div class="guest-detail-bg wap" v-if="isShowDetail">
        <div class="detail-info">
          <div class="close">
            <span
              class="icon icontemp stemp-close"
              @click="isShowDetail = false"
            ></span>
          </div>
          <div class="base-info">
            <div
              class="name"
              v-if="extras.guestName.display == 1"
              :style="{
                color:
                  extras.guestName.name == 'custom'
                    ? extras.guestName.fontColor
                    : '',

                'font-style':
                  extras.guestName.name == 'custom'
                    ? extras.guestName.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.guestName.name == 'custom'
                    ? extras.guestName.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
            >
              {{
                $i18nField(
                  guestsI18n && guestsI18n[currentGuest.seminarGuestId],
                  "name",
                  currentGuest.name
                )
              }}
            </div>
            <div class="spite-line"></div>
            <div
              class="content"
              v-if="extras.guestEnterprise.display == 1"
              :style="{
                color:
                  extras.guestEnterprise.enterprise == 'custom'
                    ? extras.guestEnterprise.fontColor
                    : '',

                'font-style':
                  extras.guestEnterprise.enterprise == 'custom'
                    ? extras.guestEnterprise.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.guestEnterprise.enterprise == 'custom'
                    ? extras.guestEnterprise.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
            >
              {{ $t("公司：")
              }}<span>{{
                $i18nField(
                  guestsI18n && guestsI18n[currentGuest.seminarGuestId],
                  "enterprise",
                  currentGuest.enterprise
                )
              }}</span>
            </div>
            <div
              class="content"
              v-if="extras.guestDuty.display == 1"
              :style="{
                color:
                  extras.guestDuty.duty == 'custom'
                    ? extras.guestDuty.fontColor
                    : '',

                'font-style':
                  extras.guestDuty.duty == 'custom'
                    ? extras.guestDuty.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras.guestDuty.duty == 'custom'
                    ? extras.guestDuty.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              }"
            >
              {{ $t("职位：")
              }}<span>{{
                $i18nField(
                  guestsI18n && guestsI18n[currentGuest.seminarGuestId],
                  "duty",
                  currentGuest.duty
                )
              }}</span>
            </div>
            <div
              class="content"
              v-if="
                currentGuest.intro ||
                (guestsI18n &&
                  guestsI18n[currentGuest.seminarGuestId] &&
                  guestsI18n[currentGuest.seminarGuestId].en_us &&
                  guestsI18n[currentGuest.seminarGuestId].en_us.intro)
              "
            >
              {{ $t("简介：")
              }}<span>{{
                $i18nField(
                  guestsI18n && guestsI18n[currentGuest.seminarGuestId],
                  "intro",
                  currentGuest.intro
                )
              }}</span>
            </div>
          </div>
          <div class="head-img">
            <img
              :src="currentGuest.realPath || defaultHeader"
              :alt="
                $i18nField(
                  guestsI18n && guestsI18n[currentGuest.seminarGuestId],
                  'name',
                  currentGuest.name
                )
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WapTitle from "@/components/wap/Title.vue";
import i18nMixin from "../../mixins/i18n";
import { tMixin } from "../../utils/i18n-t";
export default {
  components: {
    WapTitle,
  },
  mixins: [i18nMixin, tMixin],
  props: {
    guests: [],
    extras: Object,
    guestsI18n: Object,
  },
  data() {
    return {
      num: 0,
      defaultHeader: require("../../assets/images/wap/default.jpg"),
      isShowDetail: false,
      currentGuest: null,
      swiperOptions: {
        slidesPerView: 2.5,
        spaceBetween: 10,
        centeredSlides: true,
        loop: true,
        on: {
          click: (e) => {
            let index = -1;
            try {
              index = parseInt(e.target.dataset.index);
            } catch (e) {
              console.log(e);
            }
            if (index > -1) {
              this.currentGuest = this.guests[index];
              this.isShowDetail = true;
            }
          },
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },

      swiperOptions2: {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: true,
        loop: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
      },

      icon: require("@/assets/images/wap/jiabin.png"),
      title: "参会嘉宾",

      defaultColor: "#ffffff",
    };
  },
  methods: {
    showDetail(info) {
      console.log("123131331----");
      this.currentGuest = info;
      this.isShowDetail = true;
    },
  },
  mounted() {
    console.log(this.guests);

    setTimeout(() => {
      var style = document.createElement("style");

      style.innerHTML =
        ".swiper-pagination-bullet-active {background-color: " +
        (this.extras.guestStyle.button == "custom"
          ? this.extras.guestStyle.color4
          : "") +
        " !important;}";
      document.head.appendChild(style);
    }, 0);
    //    console.log("clientWidth", document.body.clientWidth);
    //    this.carouselData.width = (document.body.clientWidth + 1) / 1.8;
    //    this.carouselData.height = this.carouselData.width * 1.2;
    //    if (this.guests.length == 2) {
    //      this.guests = this.guests.push(this.guests[0]);
    //    }
  },
};
</script>
<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}
</style>
